<app-page-header icon="menu" title="Test" subtitle="Componente de prueba"></app-page-header>

<div class="seguridad-area">
  <div class="container">
    <p>test</p>
  </div>
</div>
